import { doc, setDoc } from 'firebase/firestore';
import { firestore } from '../helpers/firebase';

const setUser = async (userId, data) => {
  const setUserData = await setDoc(doc(firestore, 'users', userId), data)
    .then(() => ({ success: true, message: 'Successfully Updated!' }))
    .catch(error => ({ success: false, message: `Error Saving: ${error}` }));
  return setUserData;
};

export default setUser;
